import { defineStore } from "pinia";

const NOTIFICATION_TIMEOUT = 3000;

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    lastNotification: null,
  }),

  actions: {
    showSuccessNotification(message) {
      this.setLastNotification({
        timeout: NOTIFICATION_TIMEOUT,
        position: "center",
        color: "success",
        text: message,
      });
    },

    showErrorNotification(message) {
      this.setLastNotification({
        timeout: NOTIFICATION_TIMEOUT,
        position: "center",
        color: "error",
        text: message,
      });
    },

    setLastNotification(notification) {
      this.lastNotification = notification;
    },
  },

  getters: {
    getLastNotification: (state) => state.lastNotification,
  },
});
